import { defineStore } from 'pinia'
import { agencyAreaService, dictService } from '@/service/api'
import { lang } from '@/utils'

/** DictValueListVo */
interface DictValueListVo {
  dictCode?: string
  dictKey?: string
  dictValue?: string
  dictValueExtra1?: string
  dictValueExtra2?: string
  dictValueExtra3?: string
  dictValueExtra4?: string
  /** @format int64 */
  id?: number
  remark?: string
}

interface AGENCY_AREA_TYPE extends Record<string, any> {
  value: number | string
  label: string
}

export const useDictStore = defineStore('dicStore', {
  state: () => ({
    /**银行字典 */
    CASH_BANK: [] as DictValueListVo[],
    // 代理区列表
    AGENCY_AREA: [{ value: '', label: lang('全部') }] as AGENCY_AREA_TYPE[]
  }),
  getters:{
    getAgencyAreaDic: (state) => {
      return state.AGENCY_AREA.map((item) => ({
        value: item.value,
        label: lang(item.label)
      }))
    }
  },
  actions: {
    /**
     * 获取数据字典
     * @param dictCode 字典code
     * @returns promise
     */
    // getDictList(dictCode: string) {
    //   return new Promise((resolve, reject) => {
    //     if (dictCode === 'CASH_BANK' && this.CASH_BANK.length) return resolve(this.CASH_BANK)
    //     dictService
    //       .getList({ dictCode })
    //       .then((res) => {
    //         if (res.code === 1) {
    //           switch (dictCode) {
    //             case 'CASH_BANK':
    //               this.CASH_BANK = res.data
    //               break
    //             default:
    //               break
    //           }
    //         }
    //         resolve(res)
    //       })
    //       .catch((err) => reject(err))
    //   })
    // },
    /**
     * 获取代理区列表
     * @returns promise
     */
    getAgencyAreaList() {
      return new Promise((resolve, reject) => {
        agencyAreaService.listThAgency({})
          .then((res) => {
            if (res.code === 1) {
              this.AGENCY_AREA = [{ value: '', label: lang('全部') }].concat((res.data.map((item: any) => ({
                value: item.id,
                label: item.agencyName
              }))))
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
